import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-remove" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "shortcut"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Related shortcut keys", -1)
const _hoisted_8 = { class: "columns" }
const _hoisted_9 = { class: "col half" }

import { computed } from "vue";
import { useStore } from "vuex";
import { Shortcut } from "@/models/shortcut";
import { convertMarkdown } from "@/markdown/util/markdown.util";
import { Actions, Mutations } from "@/store";
import { useRouter } from "vue-router";
import ShortcutKey from "../shortcut/ShortcutKey.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Shortcut',
  setup(__props) {

const store = useStore();
const router = useRouter();
const shortcut = computed<Shortcut>(() => store.state.shortcut);
const shortcuts = computed(() => store.state.shortcuts);

const getShortcuts = (shortcut: Shortcut): Shortcut[] =>
  shortcuts.value.filter((s: Shortcut) => shortcut.modifiers.includes(s.id));

const edit = () => {
  store.commit(Mutations.SetShortcut, shortcut.value);
  router.push(`/shortcut/${shortcut.value.id}/edit`);
};

const remove = () => {
  store.dispatch(Actions.RemoveShortcut, shortcut.value.id);
  router.push(`/shortcut`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "buttons" }, [
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: remove
      }, [
        _hoisted_1,
        _createTextVNode(" Delete ")
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: edit
      }, [
        _hoisted_2,
        _createTextVNode(" Edit ")
      ])
    ]),
    (shortcut.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(shortcut.value.name)
          }, null, 8, _hoisted_4),
          _createVNode(ShortcutKey, { shortcut: shortcut.value }, null, 8, ["shortcut"]),
          _createElementVNode("p", {
            innerHTML: _unref(convertMarkdown)(shortcut.value.description)
          }, null, 8, _hoisted_5),
          ((shortcut.value.modifiers || []).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getShortcuts(shortcut.value), (s) => {
                      return (_openBlock(), _createElementBlock("li", null, [
                        _createVNode(ShortcutKey, { shortcut: s }, null, 8, ["shortcut"])
                      ]))
                    }), 256))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})